// src/docs/DocsPromoteProject.js
import React, { useEffect, useState } from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsPromoteProject = () => {
  // Example fee per day value (could be dynamically fetched)
  const feePerDay = 0.05; // in BNB
  const maxSlots = 10;

  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Promote Your Project
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Boosting your project's visibility is a key step to attract investors and
        build credibility. With CrowdLaunch, you can submit a promotion request
        that will feature your tokenized project on our platform. Note that only
        active, verified projects are eligible for promotion.
      </Typography>

      {/* Why Promote? */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why Promote Your Project?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Promoting your project can help you:
        <br />• Increase visibility among potential investors.
        <br />• Gain a competitive edge in a crowded market.
        <br />• Enhance your project's credibility through platform endorsement.
        <br />• Accelerate fundraising by reaching a broader audience.
      </Typography>

      {/* How Promotion Works */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How Does It Work?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        When you submit a promotion request, the following occurs:
        <br />1. <strong>Project Verification:</strong> Only projects that have been
        verified through our KYC process are eligible.
        <br />2. <strong>Fee Calculation:</strong> The fee is calculated based on the
        duration of promotion (in days) multiplied by the fixed fee per day (currently{" "}
        <strong>{feePerDay.toFixed(2)} BNB</strong>). This fee is non-refundable.
        <br />3. <strong>Limited Slots:</strong> There are only {maxSlots} promotion
        slots available. If no slots are available at the time of submission, your
        promotion will be scheduled for the next available opening.
        <br />4. <strong>Submission & Approval:</strong> Upon submission, the promotion
        request is recorded on-chain. Once approved, your project is featured,
        enhancing its visibility.
      </Typography>

      {/* Promotion Benefits */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Promotion Benefits
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Promoted projects receive:
        <br />• Increased exposure on the CrowdLaunch dashboard.
        <br />• Priority placement on the Featured Projects tab.
        <br />• A dedicated banner that highlights your project’s key details.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By leveraging CrowdLaunch’s promotion feature, you empower your project to stand out,
        attract the right attention, and accelerate your path to success. Make sure your project is
        verified and active before submitting a promotion request.
      </Typography>
    </Container>
  );
};

export default DocsPromoteProject;
